import React, { useState } from "react";
import PageTitle from "../../../Module/pageTitle";
import LabelField from "../../../Component/labelField";
import FormInputField from "../../../Component/FormInputField";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import {
  pdf_size_5MB,
  validateIsFileImageType,
} from "../../../Utils/validators";
import { validateIsFileImageTypeErrMsg } from "../../../Utils/errorMsg";
import {
  showErrorSnackbar,
  showSuccessSnackbar,
} from "../../../Action/snackbarAction";
import { useDispatch } from "react-redux";
import { addStoryType, uploadFileShort } from "../../../Action/courseAction";
import Dropdown from "../../../Component/dropdown";
const CategoriesOptions = [
  {
    _id: 1,
    name: "RESULTS",
  },
  {
    _id: 2,

    name: "EXAM NOTIFICATION",
  },
  {
    _id: 3,
    name: "CONCEPT VIDEO",
  },
  {
    _id: 4,
    name: "YOUTUBE VIDEO",
  },
  {
    _id: 5,
    name: "SUCCESS STORIES",
  },
  {
    _id: 6,
    name: "BIGGEST OFFER",
  },
  {
    _id: 7,
    name: "LAUNCH EVENT",
  },
  {
    _id: 8,
    name: "DAY CHALLENGE",
  },
];
function AddStoryType() {
  const dispatch = useDispatch();
  const [storyName, setStoryName] = useState("");
  const [storyCategories, setStoryCategories] = useState("");
  const [storyOrder, setStoryOrder] = useState("");
  const [iconImage, setIconImage] = useState("");
  const [iconUrl, setIconUrl] = useState("");

  const handleIconImageChange = (e) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > pdf_size_5MB) {
      dispatch(showErrorSnackbar("File size should be less than 5 MB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        setIconImage(reader.result);
      };
      reader.readAsDataURL(file);

      dispatch(
        uploadFileShort(file, async (resp) => {
          setIconUrl(resp?.fileUrl);
        })
      );
    }
  };

  const validations = () => {
    return (
      storyName === "" ||
      iconUrl === "" ||
      storyOrder === "" ||
      storyCategories === ""
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const reqBody = {
      name: storyName,
      icon: iconUrl,
      type: storyCategories?._id,
      order: storyOrder,
    };
    dispatch(
      addStoryType(reqBody, (res) => {
        setStoryName("");
        setIconImage("");
        setIconUrl("");
        setStoryCategories("");
        storyOrder("");
        dispatch(showSuccessSnackbar("Data Added successfully"));
      })
    );
  };
  const handleChangeOrder = (value) => {
    if (!/^[0-9]*$/.test(value)) return;
    setStoryOrder(value);
  };
  return (
    <div>
      <PageTitle name={"ADD STORY TYPE"} />
      <div className="row formDiv m-0">
        <div className="col-12 formDiv d-flex ">
          <form className="formWidth col-12" onSubmit={handleSubmit}>
            <div className=" col-md-6 d-flex mb-2 align-items-center">
              <LabelField labelName={"Categories Type"} isRequired />
              <Dropdown
                setInputText={(value) => setStoryCategories(value)}
                value={storyCategories}
                options={CategoriesOptions}
                labelName="Select Categories Type"
              />
            </div>
            <div className="d-flex mb-2 align-items-center col-6">
              <LabelField labelName={"Story Type"} isRequired />
              <FormInputField
                placeholder={"Enter Story Type"}
                setInputText={(value) => setStoryName(value)}
                value={storyName}
              />
            </div>
            <div className="d-flex mb-2 align-items-center col-6">
              <LabelField labelName={"Order"} isRequired />
              <FormInputField
                placeholder={"Order"}
                setInputText={handleChangeOrder}
                value={storyOrder}
                maxLength={3}
              />
            </div>
            <div className="d-flex mb-2 align-items-center col-md-6">
              <LabelField labelName={"Icon Image"} isRequired />
              <ImagePickerAndViewer
                value={iconImage}
                handleChange={(e) => handleIconImageChange(e)}
                htmlFor={`photo-upload`}
                Isrequired={true}
              />
            </div>
            <div className="col-auto d-flex justify-content-center">
              <div className="col-auto d-flex justify-content-center mt-4">
                <button
                  type="submit"
                  className={`btn mb-3 submitbtn ${
                    validations() ? "btn-secondary" : "btn-primary"
                  }`}
                  disabled={validations()}
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddStoryType;
